import React from 'react';

import '../Tutorial.css';
import Typewriter from "typewriter-effect";
import TutorialGirl from "../TutorialGirl";

function T240ArenaFinish() {

    const text = 'Hit Play and begin your first Arena battle. Good luck!';

    return <div>

        <div className={'T200Right'}></div>
        <div className={'T150Bottom'}></div>

        <TutorialGirl position={'Right'} undressingProcess={3}/>
        <div className='tutorialContainer tutorialTopContainer210'>
            <div className='tutorialBottomTextField'>
                <Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                />
            </div>

        </div>
    </div>
}

export default T240ArenaFinish;
